<template>
  <div class="form-area">
    <Form :disabled="disabled" style="width: 1000px;margin-top: 20px"
          :model="model"
          :label-width="110"
          label-position="right"
          :rules='rules'
          ref="form"
          inline>
      <FormItem :class="{'model-hidden': true}" label="文本框">
        <Input v-model="model.id" type="text"></Input>
      </FormItem>
      <Row>
        <FormItem style="margin-left: 800px">
          <Button type="primary" @click="save">保存</Button>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="银行名称:">
          <Input v-model="model.name" disabled style="width:500px" type="text"></Input>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="上传图标" prop="logoPic">
          <img :src="model.logoPic" width="100px" height="100px"/>
          <Upload :action="uploadUrl"
                  :before-upload="beforeAvatarUpload"
                  :on-success="(response, file)=>handleSuccess(response, file,1)"
          >
            <Button>更换图片</Button>
          </Upload>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="上传图标" prop="namePic">
          <img :src="model.namePic" width="100px" height="100px"/>
          <Upload :action="uploadUrl"
                  :before-upload="beforeAvatarUpload"
                  :on-success="(response, file)=>handleSuccess(response, file,2)"
          >
            <Button>更换图片</Button>
          </Upload>
        </FormItem>
      </Row>
    </Form>
  </div>
</template>

<script>
  import util from '@/libs/util.js';


  export default {
    name: 'editItem',

    data() {
      return {
        uploadUrl: util.baseUrl + "api/common/upload",
        //ID
        id: null,
        showModel: false,
        //表单参数
        model: {
          id: null,
          name: null,
          logoPic: null,
          namePic: null,
          type: null,
        },
        rules: {
          logoPic: [{required: true, message: '上传图标', trigger: 'change'}],
          namePic: [{required: true, message: '上传字标', trigger: 'change'}],
        },
        disabled: true,
        headers: {
          Authorization: localStorage.token,
        },
      };
    },
    mounted() {
      this.myInfo()
    },
    methods: {
      save() {
        let _this = this;
        this.$Modal.confirm({
          title: '是否保存',
          onOk: () => {
            this.$refs.form.validate(valid => {
              if (valid) {
                _this.model.type = 1
                util.http.post("/api/finance/company/save", _this.model)
                  .then(function (response) {
                    if (response.data.code === 200) {
                      _this.$message.success("保存成功")
                      _this.$parent.handleOk()
                      _this.closeModel()
                    } else {
                      _this.$message.error(response.data.message)
                    }
                  })
              }
            })
          }
        })
      },

      handleSuccess(response, file, type) {
        if (response.success) {
          if (1 === type) {
            this.model.logoPic = response.result.realPath || ''
          } else {
            this.model.namePic = response.result.realPath || ''
          }
        }
      },
      //验证是否为图片
      beforeAvatarUpload(file) {
        console.log(file, "2222222222222222");
        const isJPG = file.type === 'image/jpeg'
        const isLt2M = file.size / 1024 / 1024 < 2
        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!')
        // }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
        }
        return isLt2M
      },

      myInfo() {
        let _this = this;
        util.http.get("/api/finance/company/myCompanyInfo").then(function (response) {
          _this.tableData = [];
          let data = response.data;
          if (data.code === 200) {
            _this.model = response.data.result
            if (_this.model.type === '1') {
              _this.disabled = false
            }
          } else {
            this.$message.error(res.data.message)
          }
        }).catch(function (error) {
          console.log(error);
        });
      },

    }
  };
</script>

<style scoped>
  .button-area {
    display: flex;
    justify-content: flex-end;
  }

  .button-right-left {
    margin-right: 15px;
  }

  .button-right {
    margin-right: 55px;
  }

  .form-area {
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }

  .form-flex {
    display: flex;
    justify-content: space-between;
  }

  .model-hidden {
    display: none;
  }

  .ivu-modal {
    width: 1000px;
  }

</style>
